
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_16664_105402)"}},[_c('path',{attrs:{"d":"M8.417 13.959L5.25 10.792l1.116-1.116 2.05 2.042 5.218-5.217 1.116 1.124-6.333 6.334zM10 2.875a.792.792 0 110 1.584.792.792 0 010-1.584zm5.542 0h-3.31A2.383 2.383 0 0010 1.292c-1.03 0-1.9.665-2.232 1.583h-3.31A1.583 1.583 0 002.875 4.46v11.083a1.584 1.584 0 001.583 1.583h11.084a1.584 1.584 0 001.583-1.583V4.459a1.583 1.583 0 00-1.583-1.584z","fill-opacity":".7"}}),_c('circle',{attrs:{"cx":"3.667","cy":"15.541","fill":"#fff","r":"3.958"}}),_c('path',{attrs:{"d":"M5.834 15.934h.1v-.867h-2v-2h-.867v2h-2v.867h2v2h.867v-2h1.9z","fill":"#188038","stroke":"#188038","stroke-width":".2"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_16664_105402"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.5 .5)","d":"M0 0h19v19H0z"}})])])])
          )
        }
      }
    